import { ScreenId } from '../types';

// Navigation Items
export const NAVIGATION_ITEMS = [
  { id: 'dashboard' as ScreenId, label: 'Ana Sayfa', icon: 'fas fa-home' },
  { id: 'request-evaluation' as ScreenId, label: 'Talep Değerlendirme', icon: 'fas fa-list' },
  { id: 'draft-quote' as ScreenId, label: 'Taslak Teklif Hazırlama', icon: 'fas fa-paper-plane' },
  { id: 'negotiation-quote' as ScreenId, label: 'Müzakere Teklifi Hazırlama', icon: 'fas fa-handshake' },
  { id: 'quote-evaluation' as ScreenId, label: 'Teklif Değerlendirme', icon: 'fas fa-star' },
  { id: 'quote-tracking' as ScreenId, label: 'Teklif Mail Yönetimi', icon: 'fas fa-envelope' },
  { id: 'order-invoice-comparison' as ScreenId, label: 'Sipariş-Fatura Karşılaştırma', icon: 'fas fa-balance-scale' },
  { id: 'quote-document' as ScreenId, label: 'Teklif Belgesi', icon: 'fas fa-file-contract' },
  { id: 'purchase-order' as ScreenId, label: 'Satın Alma Siparişi Hazırlama', icon: 'fas fa-shopping-cart' },
  { id: 'product-inquiry' as ScreenId, label: 'Ürün Sorgulama', icon: 'fas fa-search' }
] as const;

// Page Titles
export const PAGE_TITLES: Record<ScreenId, string> = {
  'login': 'Giriş',
  'dashboard': 'Ana Sayfa',
  'request-evaluation': 'Talep Değerlendirme',
  'draft-quote': 'Taslak Teklif Hazırlama',
  'negotiation-quote': 'Müzakere Teklifi Hazırlama',
  'quote-evaluation': 'Teklif Değerlendirme',
  'quote-tracking': 'Teklif Mail Yönetimi',
  'order-invoice-comparison': 'Sipariş-Fatura Karşılaştırma',
  'quote-document': 'Teklif Belgesi',
  'purchase-order': 'Satın Alma Siparişi Hazırlama',
  'product-inquiry': 'Ürün Sorgulama',
  'create-request': 'Talep Oluştur'
};

// Status Types
export const STATUS_TYPES = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info'
} as const;

export const STATUS_COLORS = {
  success: 'green',
  error: 'red',
  warning: 'yellow',
  info: 'blue'
} as const;

// Modal Types
export const MODAL_TYPES = {
  DANGER: 'danger',
  WARNING: 'warning',
  INFO: 'info'
} as const;

// VAT Rates
export const VAT_RATES = {
  ZERO: 0.00,
  ONE: 0.01,
  EIGHT: 0.08,
  EIGHTEEN: 0.18
} as const;

// Default Values
export const DEFAULTS = {
  PAGE_SIZE: 10,
  DEBOUNCE_DELAY: 300,
  ANIMATION_DURATION: 300,
  SIDEBAR_WIDTH: 288,
  SIDEBAR_COLLAPSED_WIDTH: 64
} as const;

// API Endpoints (for future use)
export const API_ENDPOINTS = {
  PRODUCTS: '/api/products',
  REQUESTS: '/api/requests',
  QUOTES: '/api/quotes',
  ORDERS: '/api/orders',
  SUPPLIERS: '/api/suppliers'
} as const;

// Local Storage Keys
export const STORAGE_KEYS = {
  THEME: 'smartbuy-theme',
  USER_PREFERENCES: 'smartbuy-user-preferences',
  SIDEBAR_STATE: 'smartbuy-sidebar-state'
} as const;

// Error Messages
export const ERROR_MESSAGES = {
  NETWORK_ERROR: 'Ağ bağlantısı hatası oluştu',
  VALIDATION_ERROR: 'Lütfen tüm alanları doğru şekilde doldurun',
  UNAUTHORIZED: 'Bu işlem için yetkiniz bulunmamaktadır',
  NOT_FOUND: 'Aradığınız kayıt bulunamadı',
  SERVER_ERROR: 'Sunucu hatası oluştu'
} as const;

// Success Messages
export const SUCCESS_MESSAGES = {
  SAVED: 'Kayıt başarıyla kaydedildi',
  DELETED: 'Kayıt başarıyla silindi',
  UPDATED: 'Kayıt başarıyla güncellendi',
  CREATED: 'Kayıt başarıyla oluşturuldu'
} as const;

// Validation Rules
export const VALIDATION_RULES = {
  MIN_PASSWORD_LENGTH: 6,
  MAX_PRODUCT_NAME_LENGTH: 100,
  MIN_QUANTITY: 1,
  MAX_QUANTITY: 999999
} as const;

// Date Formats - Now handled by formatters.ts with localization
// Removed hardcoded formats to support user locale

// Currency
export const CURRENCY = {
  CODE: 'TRY',
  SYMBOL: '₺',
  LOCALE: 'tr-TR'
} as const;

// Breakpoints (Tailwind CSS)
export const BREAKPOINTS = {
  SM: 640,
  MD: 768,
  LG: 1024,
  XL: 1280,
  '2XL': 1536
} as const;

// User Roles
export const USER_ROLES = {
  ADMIN: 'Admin',
  USER: 'User',
  PURCHASER: 'Purchaser'
} as const;

export type UserRole = typeof USER_ROLES[keyof typeof USER_ROLES];